import script from "./ChannelsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelsList.vue?vue&type=script&setup=true&lang=js"

import "./ChannelsList.vue?vue&type=style&index=0&id=3e2e41ca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e2e41ca"]])

export default __exports__